class ResourceTemplate {
	constructor(el) {
		this.el = el;
		this.featuredResourceEl = this.el.querySelector('.resource__featured-resource');
		this.featuredResourceRow = this.el.querySelector('.resource__featured-resource-row');
		this.featuredId = this.featuredResourceRow?.dataset.featuredId;
		this.baseUrl = window.location.origin;
		
		this.displayFeatured();
		this.displaySearchIcon();
		this.initPaging();
		
	}

	initPaging() {
		this.el.addEventListener('click', (event) => {
			const control = event.target.closest('ul.alm-paging a');
			if (control && !control.closest('.disabled, .active')) {
				this.pageChanged = true;
				this.lastControl = control.dataset.page;
			}
		}, true);
		this.el.addEventListener('keydown', (event) => {
			const control = event.target.closest('ul.alm-paging a[role="button"]');
			if (control && event.key === ' ') {
				event.preventDefault();
				control.click();
			}
		});
		const previousComplete = window.almPagingComplete;
		window.almPagingComplete = () => {
			if (typeof previousComplete === 'function') previousComplete();
			this.enhancePaging();
		};
		this.enhancePaging();
	}

	enhancePaging() {
		const pager = this.el.querySelector('ul.alm-paging');
		if (!pager) return;

		if (!pager.closest('nav')) {
			const nav = document.createElement('nav');
			nav.setAttribute('aria-label', 'Resources pagination');
			pager.before(nav);
			nav.append(pager);
		}

		pager.querySelectorAll('a').forEach((control) => {
			const parent = control.parentElement;
			const disabled = parent.classList.contains('disabled');

			if (parent.classList.contains('num')) control.removeAttribute('role');

			control.tabIndex = disabled ? -1 : 0;
			control.setAttribute('aria-disabled', String(disabled));

			if (parent.classList.contains('prev')) {
				control.setAttribute('aria-label', 'Previous page of resources');
			}

			if (parent.classList.contains('next')) {
				control.setAttribute('aria-label', 'Next page of resources');
			}

			if (parent.classList.contains('active')) {
				control.setAttribute('aria-current', 'page');
			} else {
				control.removeAttribute('aria-current');
			}
		});

		if (!this.pageChanged) return;
		this.pageChanged = false;

		const status = this.el.querySelector('.resource__page-status');
		if (status) {
			status.textContent = `Resources: page ${pager.dataset.currentPage} of ${pager.dataset.totalPages}.`;
		}

		const firstCard = this.el.querySelector('.alm-paging-content .card__link');

		if (firstCard) {
			firstCard.focus({ preventScroll: true });
		}
	}

	displaySearchIcon () {
		const almSearch = document.getElementsByClassName('search-icon');
		if (!almSearch.length) return;
		const almSearchButton = almSearch[0].getElementsByTagName('button');
		almSearchButton[0].innerHTML = '<i class="fas fa-search"></i>';
	}
	
	

	displayFeatured = () => {
		window.almComplete = () => {
			const ajaxLoadMoreListing = document.querySelector('.alm-listing');
			const almFilters = ajaxLoadMoreListing.querySelector('.alm-filters');
			const cards = ajaxLoadMoreListing.querySelectorAll('.card');

			if (!almFilters || !this.featuredResourceRow) return;

			if (almFilters.dataset.url === this.baseUrl + '/resources/') {
				this.featuredResourceRow.classList.remove('hidden');
			} else {
				this.featuredResourceRow.classList.add('hidden');
			}
			
			cards.forEach((card) => {
				if (card.dataset.postId === this.featuredId && almFilters.dataset.url === this.baseUrl + '/resources/') {
					card.classList.add('hidden');
				}
			});
		};
	}

	
}

export default ResourceTemplate;
